// src/core/signalr-events.ts

import { connectSignalR } from './signalr';

let initialized = false;

export async function initSignalREvents(): Promise<void> {

    const connection = await connectSignalR();

    if (initialized) {
        return;
    }

    initialized = true;

    connection.on('RealtimeMessage', data => {
        console.log('[SignalR] RealtimeMessage:', data);

        window.dispatchEvent(
            new CustomEvent('realtime-message', {
                detail: data
            })
        );
    });

    connection.on('NotificationReceived', data => {
        console.log('[SignalR] NotificationReceived:', data);

        window.dispatchEvent(
            new CustomEvent('notification-received', {
                detail: data
            })
        );
    });
}